/** 레슨 목록에 노출할 실제 강사 (Firestore instructors 컬렉션 name 기준) */
export const ALLOWED_LESSON_INSTRUCTOR_NAMES = ["김한나"] as const;

/** 목록·초대에서 숨긴 강사 */
export const DISABLED_LESSON_INSTRUCTOR_NAMES = [
  "양태욱",
  "베토벤",
  "유준혁",
] as const;

/** 알려진 강사 UID (Firestore instructors 문서 ID) */
export const KNOWN_LESSON_INSTRUCTORS = {
  양태욱: {
    uid: "oXne74xc6tRIPerDDuLJ7rtPmtm2",
    nickname: "나르형",
  },
  김한나: {
    uid: "kim-hanna",
    nickname: "김한나",
  },
} as const;

export function isAllowedLessonInstructor(name: string): boolean {
  if ((DISABLED_LESSON_INSTRUCTOR_NAMES as readonly string[]).includes(name)) {
    return false;
  }
  return (ALLOWED_LESSON_INSTRUCTOR_NAMES as readonly string[]).includes(name);
}

export function getActiveLessonInstructorName(): string {
  return ALLOWED_LESSON_INSTRUCTOR_NAMES[0];
}

/** 비활성 프로(양태욱 등) 이름은 건너뛰고, 공개 중인 프로만 고릅니다. */
export function resolvePublicLessonInstructorName(
  ...candidates: Array<string | null | undefined>
): string {
  for (const candidate of candidates) {
    const name = candidate?.trim();
    if (name && isAllowedLessonInstructor(name)) return name;
  }
  return getActiveLessonInstructorName();
}

/** 동료 강사 초대 대상 (본인 제외) */
export function getInvitableInstructorNames(excludeName?: string): string[] {
  return ALLOWED_LESSON_INSTRUCTOR_NAMES.filter(name => name !== excludeName);
}

/** 전용 강의실 초대 코드 prefix (예: BET-A3K9) */
export function studioInvitePrefix(instructorName: string): string {
  const ascii = instructorName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z]/g, "")
    .toUpperCase();
  if (ascii.length >= 3) return ascii.slice(0, 4);
  const map: Record<string, string> = {
    베토벤: "BET",
    양태욱: "NARU",
    김한나: "HANNA",
    유준혁: "YJH",
  };
  return map[instructorName] || "ROOM";
}

/** 초대 코드 생성 (예: NARU-A3K9) */
export function generateLessonInviteCode(prefix = "CT"): string {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let suffix = "";
  for (let i = 0; i < 4; i++) {
    suffix += chars[Math.floor(Math.random() * chars.length)];
  }
  return `${prefix}-${suffix}`;
}
